import axiosInstance from './axiosInstance';

// ------------------------------------------------------------------------------------------------ //
// !Auth
export const logout = async () => {
	let res = await axiosInstance.post('/logout');
	return res;
};

export const userLogin = async (data: { email: string; password: string }): Promise<any> => {
	let res = await axiosInstance.post('/login', data);
	return res.data;
};

export const userForgotPassword = async (data: { email: string }): Promise<any> => {
	let res = await axiosInstance.post('/forgot-password', data);
	return res.data;
};

export const resetPassword = async (data: { key: string; email: string; password: string; password_confirmation: string }): Promise<any> => {
	let res = await axiosInstance.post(`/reset-password`, data);
	return res.data;
};

export const ChangePass = async (data: { old_password: string; password: string; password_confirmation: string }): Promise<any> => {
	let res = await axiosInstance.post(`/change-password`, data);
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// !Help Center

export const getFaqs = async () => {
	let res = await axiosInstance.get('/faqs');
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// !user Profile

export const getUserData = async () => {
	let res = await axiosInstance.get('/user/get-data');
	return res.data;
};

export const getCountries = async () => {
	let res = await axiosInstance.get('/countries');
	return res.data;
};

export const getCitiesbyId = async (id: number) => {
	let res = await axiosInstance.get(`/countries/get-cities/${id}`);
	return res.data;
};

export const changeUserData = async (data: {
	about: string;
	name: string;
	gender: string;
	date_of_birth: string;
	city_id?: number | null;
	country_id?: number | null;
}): Promise<any> => {
	let res = await axiosInstance.post(`/user/set-data`, data);
	return res.data;
};

export const changeUserPhoto = async (photo: FormData) => {
	let res = await axiosInstance.post('/user/set-photo', photo);
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// Notification System

export type paramsType = {
	new?: boolean;
};

export const getallNotifiactions = async (params?: paramsType) => {
	let res = await axiosInstance.get('/notifications', { params: params });
	return res.data;
};

export const getunreadNotifiactions = async () => {
	let res = await axiosInstance.get('');
	return res.data;
};

export const markReadAllNotif = async () => {
	let res = await axiosInstance.post('/notifications/mark-all/as-read');
	return res.data;
};

export const markOneAsRead = async (slug) => {
	let res = await axiosInstance.get(`/notifications/${slug}`);
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// !Calender
export type calenderData = {
	start: string;
	end: string;
};
export const getcalenderData = async (data: calenderData) => {
	let res = await axiosInstance.get(`/calender/get/data`, { params: data });
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// !User Teams
export const getTeams = async () => {
	return await axiosInstance.get('/teams/my-teams', {
		params: { paginate: true },
	});
};
export const getAllTeams = async () => {
	return await axiosInstance.get('/teams/my-teams', {
		params: { paginate: false },
	});
};

export const getOneTeam = async (slug: string) => {
	let res = await axiosInstance.get(`/teams/${slug}`);
	return res.data;
};

// ------------------------------------------------------------------------------------------------ //
// !User Rounds

export const getRounds = async (queries: any) => {
	return await axiosInstance.get('/rounds/of/user', { params: queries });
};

// ------------------------------------------------------------------------------------------------ //
// !User Activities

export const getActivities = async (slug: string, queries: any) => {
	return await axiosInstance.get(`/activities/of/user/${slug}`, {
		params: queries,
	});
};

// MyActivity

export const getActivity = async (activitySlug) => {
	return await axiosInstance.post(`/activities/playing/${activitySlug}`).then((res) => res.data);
};

export const submitActivity = async (data: FormData): Promise<any> => {
	let res = await axiosInstance.post(`/activities/submit-standard`, data);
	return res.data;
};

// !Tournaments Table
export const getTournaments = async () => {
	return await axiosInstance.get(`/tournaments-with-standing/`).then((res) => res.data);
};

export const getTournamentStanding = async (slug) => {
	return await axiosInstance.get(`/get-standing/of/${slug}`).then((res) => res.data);
};

// !CUP KNOCKOUTS
export const getCups = async () => {
	return await axiosInstance.get(`/cups-of-user`).then((res) => res.data);
};

export const getCupKnockouts = async (slug: string) => {
	return await axiosInstance.get(`/cups/get-standing/of/${slug}`).then((res) => res.data);
};
